var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-app',[_c('div',{staticClass:"reputation-app",class:{ 'reputation-app--narrow': _vm.isLocationStep }},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }